class LoadMore extends HTMLElement {
  constructor(){
    super()
    
    this.addEventListener('click', this.loadMoreContent.bind(this))
  }

  loadMoreContent() {
    if(this.classList.contains('collection__load-more--hidden') || this.classList.contains('collection__load-more--loaded')) return
    this.classList.add('collection__load-more--loaded')
    let url = this.dataset.next
    fetch(url)
    .then(response => {
      return response.text()
    })
    .then(html => {
      let collectionList = document.querySelector('.collection__list')
      let nextCollectionHTML = new DOMParser().parseFromString(html, 'text/html')
      nextCollectionHTML.querySelectorAll('.collection__item--product').forEach(item => {
        collectionList.appendChild(item)  
      })
      let nexButton = nextCollectionHTML.querySelector('.collection__load-more')
      if (nexButton) {
        this.classList.toggle('collection__load-more--hidden', nexButton.classList.contains('collection__load-more--hidden'))
        this.dataset.next = nexButton.dataset.next
      }
      this.classList.remove('collection__load-more--loaded')
    })
  }
}

customElements.define('load-more', LoadMore)